import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Sets default Content-Type and Accept headers for all outgoing HTTP requests.
 * Only applies defaults when headers are not already explicitly set by the caller,
 * allowing services to override for XML or other content types.
 */
export const defaultHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  let headers = req.headers;

  // Leave FormData bodies untouched so the browser can set the multipart
  // boundary; forcing application/json here would corrupt file uploads.
  const isFormData = req.body instanceof FormData;

  if (!isFormData && !headers.has('Content-Type')) {
    headers = headers.set('Content-Type', 'application/json');
  }
  if (!headers.has('Accept')) {
    // Match Accept to Content-Type when sending XML, otherwise default to JSON
    const contentType = headers.get('Content-Type') || '';
    headers = headers.set('Accept', contentType.includes('xml') ? 'application/xml' : 'application/json');
  }

  return next(req.clone({ headers }));
};
